<template>
	<div class="content background6" style="height: 100%;">
		<div class="tableBox9">
			<div class="tableMes">
				<div class="table">
					<el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
						<el-tab-pane :label="$t('label_429')" name="first">
							<tree :dataTree="treeData" :treeType="0" @getDeviceMes="getDeviceMes"></tree>
						</el-tab-pane>
						<el-tab-pane :label="$t('label_161')" name="second">
							<tree :dataTree="treeData2" :treeType="1" @getDeviceMes="getDeviceMes"></tree>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
		<div class="tableBox10">
			<div class="tableMes">
				<div class="table" style="padding: 0">
					<div class="treeMes" v-if="getTreeMes=='1'">
						<p class="title"><span class="spot">{{deviceDetailMes.name}}</span>{{$t('label_759')}}</p>
						<div class="chooseBox spaceBetween">
							<div class="selectBox">
								<div>
									<div class="selectChoose">
										<div class="selectText">
											<p>{{$t('label_389')}}</p>
										</div>
										<div class="select" style="width:350px">
											<el-input v-model="code" clearable></el-input>
										</div>
									</div>
								</div>
								<div>
									<div class="selectChoose">
										<div class="selectText">
											<p>{{$t('label_70')}}</p>
										</div>
										<div class="select" style="width:350px">
											<el-date-picker v-model="Readytime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange"
											 :range-separator="$t('label_264')" :start-placeholder="$t('label_329')" :end-placeholder="$t('label_388')">
											</el-date-picker>
										</div>
									</div>
								</div>
							</div>
							<div class="buttonBox">
								<div>
									<div class="chooseButton sendButton" @click="search({pageNum: 1,pageSize:pageSize,})"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
								</div>
							</div>
						</div>
						<div class="spotMes2Box">
<!--							<div class="buttonBox">-->
<!--								<div>-->
<!--									<div class="chooseButton searchButton" @click="exportClick" v-if="MenuRoleList.indexOf('61')>=0"><i class="el-icon-download"></i>导出</div>-->
<!--								</div>-->
<!--							</div>-->
							<div class="spotMesBox  spotMesBoxs" style="height:100%;">
								<el-tabs v-model="activeNameSpot"  @tab-click="search">
									<el-tab-pane :label="$t('label_1023')" name="g" v-if="MenuRoleList.indexOf('9')>=0">
										<GzgraphicStatistics ref="GzgraphicStatisticsDisplay"></GzgraphicStatistics>
									</el-tab-pane>
									<el-tab-pane :label="$t('label_1024')" name="t" v-if="MenuRoleList.indexOf('13')>=0">
										<GztabularStatistics ref="GztabularStatisticsDisplay"></GztabularStatistics>
									</el-tab-pane>
								</el-tabs>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
		<!-- 导出 -->
		<exportMes :exportTitle="exportTitle" :exportData="tableDataTreeTimeExport" :exportList="exportList" ref="exportBox"></exportMes>
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import utils from '@/utils/utils'
	import tree from "@/components/list/tree/maintainTree";
	import SpotCheck from "@/assets/js/spotCheck/spotCheck.js";
	import file from "@/assets/js/file/file.js";
	import popMesBox from "@/components/list/popover/pop";
	import GztabularStatistics from "@/components/list/tabPane/GztabularStatistics";
	import GzgraphicStatistics from "@/components/list/tabPane/GzgraphicStatistics";
	import exportMes from "@/components/list/export/export";
	import statistics from "@/assets/js/statistics/statistics.js";
	export default {
		name: 'equipmentDesign',
		components: {
			Page,
			tree,
			popMesBox,
			GztabularStatistics,
			GzgraphicStatistics,
			exportMes
		},
		data() {
			return {
				activeNameSpot: 'g',
				dateValue: [],
				pageNum: 1,
				pageSize: 10,
				pageCount: 0,
				Readytime: '',
				code: '',
				getTreeMes: '1',
				img: '',
				checked: false,
				dialogImg: false,
				dialogVideo: false,
				dialogSpotRemark: false,
				deviceDetailMes: {},
				dialogSpotResult: false,
				MenuRoleList: [],
				newType: {
					id: '',
					remark: ''
				},
				exportTitle: '设备原因统计',
				exportList: [{
					column: 'faultReason',
					title: '原因名称',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'repairNum',
					title: '故障回数',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, {
					column: 'repairTime',
					title: '故障时长(分)',
					headerAlign: 'center',
					align: 'center',
					width: '200px'
				}, ],
				tableDataTree: [],
				tableDataTreeInfo: [],
				tableDataInfo: [],
				typeName: '',
				deptName: '',
				treeData: {
					dataDevice: [],
					searchShow: true,
					statusShow: false,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '2'
				},
				treeData2: {
					dataDevice: [],
					searchShow: true,
					statusShow: false,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '3'
				},
				tableDataTreeTimeExport: [],
				checkList: [],
				weekendMesOptions: [this.$t('label_716'), this.$t('label_719'), this.$t('label_721'), this.$t('label_723'), this.$t('label_725'), this.$t('label_728'), this.$t('label_730')],
				monthDOptions: [],
				monthOptions: [this.$t('label_245'), this.$t('label_242'), this.$t('label_238')],
				monthOptionsObj: {
					// this.$t('label_245'): ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
					// this.$t('label_242'): ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
					// this.$t('label_238'): ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
				},
				tableDataTreeTime: [],
				statusText: [{
						id: '0',
						text: '启用',
						color: '#3fb393'
					},
					{
						id: '1',
						text: '停用',
						color: '#fe0000'
					},
					{
						id: '2',
						text: '未启用',
						color: '#ffb400'
					},
					{
						id: '3',
						text: '无计划',
						color: '#000000'
					},
				],
				activeNameTree: 'first',
				status: '',
			}
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			}
		},
		methods: {

			//获取时间的默认值
			getDate() {
				let start = this.Fungetdate(-30) // 7天前
				let end = this.Fungetdate(0) // 当前时间
				this.dateValue.push(start, end)
				this.Readytime = this.dateValue
			},
			//  当前时间
			Fungetdate(num) {
				var sdd = new Date();
				sdd.setDate(sdd.getDate() + num);
				var yyyy = sdd.getFullYear();
				// var MM = sdd.getMonth() + 1;//获取当前月份的日期
				let MM = sdd.getMonth() + 1 < 10 ? '0' + (sdd.getMonth() + 1) : sdd.getMonth() + 1
				var dd = sdd.getDate() < 10 ? '0' + sdd.getDate() : sdd.getDate()
				return yyyy + "-" + MM + "-" + dd;
			},
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			//导出
			exportClick() {
				this.$refs.exportBox.setExportExcel();
			},
			//初始化时间
			initDate() {
				var date = new Date();
				var seperator = "-";
				var year = date.getFullYear();
				var month = date.getMonth() + 1;
				var day = date.getDate();
				//开始时间
				var beginTime = year + seperator + this.zero(month) + seperator + '01';
				//结束时间
				var endTime = this.getday(year + seperator + this.zero(month) + seperator + this.zero(day));
				this.Readytime = [beginTime, endTime];
				this.search();
			},
			//补0
			zero(i) {
				return i > 9 ? i : '0' + i;
			},
			//最后一天
			getday(val) {
				var nextMonthFirstDay = new Date(val.substring(0, 4), val.substring(5, 7), 1);
				var oneDay = 1000 * 60 * 60 * 24;
				var lastTime = new Date(nextMonthFirstDay - oneDay);
				var day = lastTime.getDate();
				var month = parseInt(lastTime.getMonth() + 1);
				if (month < 10) {
					month = '0' + month
				}
				if (day < 10) {
					day = '0' + day
				}
				return lastTime.getFullYear() + '-' + month + '-' + day + ' ';
			},
			show(id, type) {
				this.img = id;
				if (type == "video") {
					this.dialogVideo = true;
				} else if (type == "photo") {
					this.dialogImg = true;
				}

			},


			handleClickTree(tab, event) {
				this.getTreeMes = '1';
				this.deviceDetailMes = {};

			},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			handleCurrentChangeTreeTime(info) {
				this.tableDataInfo = info;
			},

			changeSelectMonth() {
				this.tableDataTreeEdit.monthD = '';
				for (const k in this.monthOptions) {
					if (this.tableDataTreeEdit.month === this.monthOptions[k]) {
						this.monthDOptions = this.monthOptionsObj[this.tableDataTreeEdit.month]
					}
				}
			},
			search() {
				var p = {
					beginTime: this.Readytime[0] + ' 00:00:00',
					endTime: this.Readytime[1] + ' 23:59:59',
					name: this.code,
					type: this.deviceDetailMes.type,
					id: this.deviceDetailMes.id
				}
				this.$nextTick(() => {
					if (this.activeNameSpot == "g") {
						this.$refs.GzgraphicStatisticsDisplay.newMes(p)
					} else {
						this.$refs.GztabularStatisticsDisplay.newMes(p)
					}
				})
				//调接口
				statistics.repair2Excel(p).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataTreeTimeExport = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			getDeviceMes(data) {
				if (data.name == this.$t('label_272')) {
					this.deviceDetailMes = {};
					this.deviceDetailMes.type = 0
					if (this.activeNameTree == 'second') {
						this.deviceDetailMes.type = 2
					}
					this.deviceDetailMes.id = null
					this.search();
				} else {
					this.deviceDetailMes = data;
					this.search();
				}
			},

			getNowTime() {
				let zeroTime = new Date();
				let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() + 1; //月份从0开始，因此要+1
				let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
				let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
				return now;
			},
			getBeforeTime() {
				var time = (new Date).getTime() + 24 * 60 * 60 * 1000;
				let zeroTime = new Date(time);
				let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() + 1; //月份从0开始，因此要+1
				let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
				let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
				return now;
			},
		},
		created() {
			this.MenuRoleList = this.$store.getters.getMenu;
			this.initDate();
      this.$set(this.monthOptionsObj, this.$t('label_245'), ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']);
      this.$set(this.monthOptionsObj, this.$t('label_242'), ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20']);
      this.$set(this.monthOptionsObj, this.$t('label_238'), ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31']);
		}
	}
</script>

<style>
	.spotMesBoxs .el-tabs__nav-scroll {
		display: flex;
		justify-content: flex-end;
	}
</style>



// WEBPACK FOOTER //
// src/pages/statisticalAnalysis/faultStatistics.vue